import { render, staticRenderFns } from "./CoursewareTree.vue?vue&type=template&id=39958787&"
import script from "./CoursewareTree.vue?vue&type=script&lang=js&"
export * from "./CoursewareTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports